import React from 'react';

const MockSubscriptions: React.FC = () => {
  return (
    <div className="p-4 bg-white">
      <h2 className="text-lg font-bold text-gray-900 mb-2">Manage Subscriptions</h2>
      <p className="text-sm text-gray-600 mb-4">
        Subscribe to see other users' reservations on your calendar.
      </p>

      {/* Subscribe to All Toggle */}
      <div className="bg-purple-50 border border-purple-200 rounded-lg p-3 mb-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-purple-900">Subscribe to All Users</p>
            <p className="text-xs text-purple-700">Automatically see all reservations</p>
          </div>
          <div className="w-10 h-6 bg-purple-600 rounded-full relative">
            <div className="absolute right-0.5 top-0.5 w-5 h-5 bg-white rounded-full shadow" />
          </div>
        </div>
      </div>

      {/* User List */}
      <div className="space-y-2">
        <p className="text-xs font-medium text-gray-700 mb-2">Or select individual users:</p>

        {[
          { name: 'Alice Johnson', email: 'alice@example.com', subscribed: true },
          { name: 'Bob Smith', email: 'bob@example.com', subscribed: true },
          { name: 'Carol White', email: 'carol@example.com', subscribed: false },
        ].map((user, i) => (
          <div key={i} className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
            <div>
              <p className="text-sm font-medium text-gray-900">{user.name}</p>
              <p className="text-xs text-gray-500">{user.email}</p>
            </div>
            <button
              className={`text-xs px-3 py-1 rounded-full ${
                user.subscribed
                  ? 'bg-green-100 text-green-700'
                  : 'bg-gray-200 text-gray-600'
              }`}
            >
              {user.subscribed ? 'Subscribed' : 'Subscribe'}
            </button>
          </div>
        ))}
      </div>

      {/* Close Button */}
      <button className="w-full mt-4 px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg">
        Close
      </button>
    </div>
  );
};

export default MockSubscriptions;
